<template>
  <Dialog :visible.sync="innerVisible" width="490px" hideTitle top="50vh">
    <template #title></template>
    <el-row type="flex" class="tab-wrapper">
      <el-tabs value="1" class="my-tabs">
        <el-tab-pane label="忘记密码" name="1"></el-tab-pane>
      </el-tabs>
      <div class="tips">（请输入您当时申请账号时使用的联系电话和邮箱）</div>
    </el-row>
    <el-row type="flex">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="right"
        label-width="100px"
        class="form"
      >
        <el-form-item prop="account" label="系统账号">
          <el-input v-model="form.account" placeholder="请输入系统账号">
          </el-input>
        </el-form-item>
        <el-form-item prop="phone" label="联系电话">
          <el-input v-model="form.phone" placeholder="请输入联系电话">
          </el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="form.email" placeholder="请输入邮箱"> </el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="handleSubmit" class="btn"
        >确认</el-button
      >
    </el-row>
  </Dialog>
</template>

<script>
import visibleMixin from "@/mixins/visibleMixin";
import { retrievePasswordRules as rules } from "@/utils/validator";
import Dialog from "@/components/Dialog.vue";

export default {
  mixins: [visibleMixin],

  components: {
    Dialog,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        account: "", // 系统账号
        phone: "", // 联系电话
        email: "", // 邮箱
      },
      rules,
    };
  },

  watch: {
    innerVisible() {
      this.$refs.form?.resetFields();
    },
  },

  methods: {
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        let { account, phone, email } = this.form;
        if (!phone && !email) {
          this.$message.error("请填写联系电话或邮箱");
          return;
        }
        let { success, msg } = await this.$api.retrievePassword({
          systemUserId: account,
          telephone: phone,
          email,
        });
        if (success) {
          this.$message.success(msg);
          this.innerVisible = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$line-height: 25px;

.el-dialog__wrapper {
  &.dialog {
    /deep/ .el-dialog {
      transform: translateY(-50%);
    }
    /deep/ .el-dialog__header {
      .el-dialog__title {
        color: #000;
        font-weight: 600;
      }
      .el-dialog__close {
        font-size: 22px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    /deep/ .el-dialog__body {
      padding: 35px 30px 40px;
      .el-tabs__header {
        margin-bottom: 36px;
        .el-tabs__item {
          margin-bottom: 12px;
          height: auto;
          line-height: $line-height;
          color: #323233;
        }
      }
      .el-form {
        width: 100%;
        .el-form-item {
          position: relative;
          margin-bottom: 49px;
          &:last-child {
            margin-bottom: 65px;
            .el-form-item__label {
              padding-right: calc(12px + 2em);
            }
          }
          &::after {
            content: "";
            position: absolute;
            bottom: -24px;
            width: 100%;
            height: 2px;
            background: #ebeef5;
          }
        }
        .el-form-item__label {
          @extend .f18;
          color: #323233;
          line-height: $line-height;
        }
        .el-form-item__content {
          line-height: $line-height;
          .el-select {
            width: 76px;
            color: #000;
          }
          .el-input__inner {
            @extend .f18;
            color: #000;
            border: none;
            height: auto;
            line-height: $line-height;
          }
          .el-input-group__prepend {
            &::after {
              content: "";
              display: inline-block;
              position: relative;
              left: 20px;
              width: 1px;
              height: 27px;
              background: #ebeef5;
              vertical-align: middle;
            }
          }
          .btn-send-code {
            padding: 0;
            width: 90px;
            height: 32px;
            border-radius: 5px;
            color: #409eff;
            border: 1px solid #409eff;
          }
        }
      }
    }
  }
}
.text {
  color: #323233;
  &-register {
    margin: 41px 0 40px;
  }
  &-login {
    margin: 16px 0 40px;
    .btn-register {
      padding: 0;
      @extend .f18;
      line-height: 1;
    }
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: initial;
  }
  .el-radio__label {
    padding-left: 8px;
  }
  &-hyperlink {
    margin-bottom: 40px;
    color: #409eff;
  }
}
.btn {
  width: 100%;
  height: 48px;
  background: #1890ff;
  border-radius: $border-radius;
}

.tips {
  align-self: auto;
  line-height: 1.8;
  color: #C0C4CC;
}
</style>
